/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import Content from "../../../../Components/Dashboard/Content/Content";
import { useFormik } from "formik";
import FullDataTable from "../../../../Components/ExtraComponents/Datatable/BasicDataTable";
import Formikform1 from "../../../../Components/ExtraComponents/Form/Formik_form1";
import * as valid_err from "../../../../Utils/Common_Messages";
import { useDispatch } from "react-redux";
import { Get_All_Service_for_Client } from "../../../../ReduxStore/Slice/Common/commoSlice";
import ToastButton from "../../../../Components/ExtraComponents/Alert_Toast";
import toast from "react-hot-toast";
import { fDateTimeSuffix } from "../../../../Utils/Date_formet";
import { Trash2 } from "lucide-react";
import {
  Add_Message_Broadcast,
  Getl_All_Message_Broadcast,
  Remove_Message_Broadcast,
} from "../../../../ReduxStore/Slice/Admin/MessageBroadcastSlice";
import { GET_PANEL_BROKERS } from "../../../../ReduxStore/Slice/Superadmin/SuperAdminSlice";
import * as Config from "../../../../Utils/Config";
import Table from "../../../../Components/ExtraComponents/Tables/FullDataTable";

const MsgBroadCast = () => {
  const dispatch = useDispatch();
  const user_token = JSON.parse(localStorage.getItem("user_details")).token;

  const [AllStrategy, setAllStrategy] = useState({ loading: true, data: [] });
  const [AllMessage, setAllMessages] = useState({ loading: true, data: [] });
  const [UserDetails, setUserDetails] = useState({ loading: true, data: [] });
  const [AllBrokers, setBrokers] = useState([
    {
      name: "CoinDCX",
      id: 1,
    },
    {
      name: "Delta Exchange",
      id: 2,
    },
    {
     name: "CoinSwitch",
      id: 5,
    },
    {
      name: "pifourtwo",
      id: 6,
    },


  ]);
  const [refresh, setRefresh] = useState(false);

  const formik = useFormik({
    initialValues: {
      message: null,
      Strategy: "All",
    },
    validate: (values) => {
      const errors = {};
      if (!values.message) {
        errors.message = "Please Enter Message";
      }
      return errors;
    },
    onSubmit: async (values) => {
      const req = {
        Broker: values.Broker,
        message: values.message,
        starteg_id: values.Strategy ? values.Strategy : "All",
      };

      await dispatch(Add_Message_Broadcast({ req: req, token: user_token }))
        .unwrap()
        .then((response) => {
          if (response.status === 409) {
            toast.error(response.data.msg);
          } else if (response.status) {
            setRefresh(!refresh);
            formik.setFieldValue("message", "");
            formik.setFieldValue("Strategy", "");
          } else if (!response.status) {
            toast.error(response.msg);
          }
        });
    },
  });

  const fields = [
    {
      name: "Broker",
      label: "Broker",
      type: "select",
      options: [
        { label: "All Users", value: "-1" },
        { label: "Demo", value: "0" },
        ...(AllBrokers &&
          AllBrokers.map((item) => ({ label: item.name, value: item.id }))),
      ],
      label_size: 12,
      col_size: 3,
      disable: false,
    },
    {
      name: "message",
      label: "Entery Your Message",
      type: "msgbox",
      label_size: 12,
      row_size: 3,
      col_size: 12,
      disable: true,
    },
  ];

  //  FOR GET ALL BROADCAST MESSAGES
  const GetAllMsg = async () => {
    await dispatch(
      Getl_All_Message_Broadcast({
        req: {},
        token: user_token,
      })
    )
      .unwrap()
      .then((response) => {
        if (response.status) {
          setAllMessages({
            loading: false,
            data: response.data,
          });
        }
      });
  };

  useEffect(() => {
    GetAllMsg();
  }, [refresh]);

  //  REMOVE BROADCAST MESSAGES
  const Remove_Message = async (id) => {
    if (window.confirm("Do You Really Want To Remove ")) {
      await dispatch(
        Remove_Message_Broadcast({
          id: id,
          token: user_token,
        })
      )
        .unwrap()
        .then((response) => {
          if (response.status === 409) {
            toast.error(response.data.msg);
          } else if (response.status) {
            toast.success(response.msg);
            setRefresh(!refresh);
          } else if (!response.status) {
            toast.error(response.msg);
          }
        });
    }
  };

  const columns = [
    {
      name: "Message",
      selector: (row) => row.Message,
      cell: (row) => (
        <div className="enhanced-message-cell">
          <div className="message-icon">💬</div>
          <div className="message-content">
            <span className="message-text">{row.Message}</span>
          </div>
        </div>
      ),
      sortable: true,
      wrap: true,
    },
      {
      name: "Type",
      selector: (row) => row.broker_id,
      cell: (row) => (
        <div className="enhanced-message-cell">
          <div className="message-icon">💬</div>
          <div className="message-content">
            <span className="message-text">{row.broker_id == -1 ? "All Users" : row.broker_id == 0 ? "Demo" : row.broker_id == 1 ? "Coin Dcx" : row.broker_id == 2 ? "Delta Exchange" : "Unknown"}</span>
          </div>
        </div>
      ),
      sortable: true,
      wrap: true,
    },
    {
      name: "Created At",
      selector: (row) => row.createdAt,
      cell: (row) => (
        <div className="enhanced-date-cell">
          <i className="fas fa-clock me-2" style={{ color: "#6366f1", fontSize: "0.9rem" }}></i>
          <span className="date-text">
            {row.createdAt ? fDateTimeSuffix(row.createdAt) : "-"}
          </span>
        </div>
      ),
      sortable: true,
      width: "200px",
    },
    {
      name: "Actions",
      cell: (row) => (
        <div className="enhanced-action-cell">
          <span 
            data-toggle="tooltip" 
            data-placement="top" 
            title="Delete"
            className="delete-action-wrapper"
          >
            <Trash2
              size={20}
              color="#d83131"
              strokeWidth={2}
              className="mx-1 delete-icon"
              onClick={() => Remove_Message(row._id)}
              style={{ cursor: "pointer" }}
            />
          </span>
        </div>
      ),
      ignoreRowClick: true,
      allowOverflow: true,
      button: true,
      width: "300px",
    },
  ];

  return (
    <>
      <style>{`
       
        @keyframes pulse {
          0%, 100% { transform: scale(1); }
          50% { transform: scale(1.05); }
        }

        @keyframes float {
          0%, 100% { transform: translateY(0px); }
          50% { transform: translateY(-10px); }
        }

        .broadcast-container {
        
          border-radius: 20px;
          padding: 2rem;
          margin-bottom: 2rem;
          position: relative;
          overflow: hidden;
          animation: slideInDown 0.8s ease-out;
        }

        .broadcast-container::before {
          content: '';
          position: absolute;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
          background: url('https://images.unsplash.com/photo-1557804506-669a67965ba0?ixlib=rb-4.0.3&auto=format&fit=crop&w=1000&q=80') center/cover;
          opacity: 0.1;
          z-index: 1;
        }

        .broadcast-content {
          position: relative;
          z-index: 2;
        }

        .broadcast-header {
          text-align: center;
          margin-bottom: 2rem;
        }

        .broadcast-title {
         
          font-size: 2.5rem;
          font-weight: 700;
          margin-bottom: 0.5rem;
          text-shadow: 2px 2px 4px rgba(0,0,0,0.3);
        }

        .broadcast-subtitle {
          color: rgba(255,255,255,0.9);
          font-size: 1.1rem;
          font-weight: 400;
        }

        .broadcast-icon {
          width: 80px;
          height: 80px;
          background: rgba(255,255,255,0.2);
          border-radius: 50%;
          display: flex;
          align-items: center;
          justify-content: center;
          margin: 0 auto 1rem;
          animation: float 3s ease-in-out infinite;
        }

        .enhanced-form-container {
         
          border-radius: 20px;
          padding: 1.5rem;
          box-shadow: 0 10px 40px rgba(0,0,0,0.1);
          margin-bottom: 2rem;
          animation: fadeInUp 0.8s ease-out 0.2s both;
          border: 1px solid #e5e7eb;
        }

  

        .form-header {
          margin-bottom: 1.5rem;
          padding-bottom: 1rem;
          border-bottom: 2px solid #f1f5f9;
        }

        .form-title1 {
       
          font-size: 1.5rem;
          font-weight: 600;
        
        }

        .form-description {
        
          font-size: 0.95rem;
        }

        .enhanced-table-wrapper {
       
          border-radius: 20px;
          box-shadow: 0 10px 40px rgba(0,0,0,0.1);
          overflow: hidden;
          animation: fadeInUp 0.8s ease-out 0.4s both;
          border: 1px solid #e5e7eb;
        }

        .table-header {
          padding: 1.5rem;
          border-bottom: 1px solid #e5e7eb;
        }

       

       

        .enhanced-message-cell {
          display: flex;
          align-items: center;
          padding: 0.5rem 0;
        }

        .message-icon {
          font-size: 1.2rem;
          margin-right: 0.75rem;
          animation: pulse 2s infinite;
        }

        .message-content {
          flex: 1;
        }

        .message-text {
          color: #374151;
          font-weight: 500;
          line-height: 1.5;
        }

        .enhanced-date-cell {
          display: flex;
          align-items: center;
          color: #6b7280;
          font-weight: 500;
        }

        .date-text {
          font-size: 0.9rem;
        }

        .enhanced-action-cell {
          display: flex;
          justify-content: center;
        }

        .delete-action-wrapper {
          position: relative;
          display: inline-block;
        }

        .delete-icon {
          transition: all 0.3s ease;
          padding: 0.5rem;
          border-radius: 8px;
          background: rgba(248, 113, 113, 0.1);
        }

        .delete-icon:hover {
          background: rgba(248, 113, 113, 0.2);
          transform: scale(1.1);
          color: #dc2626 !important;
        }

        .broadcast-stats {
          display: grid;
          grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
          gap: 1.5rem;
          margin-bottom: 2rem;
        }

        .stat-card {
          background: rgba(255,255,255,0.15);
          backdrop-filter: blur(10px);
          border: 1px solid rgba(255,255,255,0.2);
          border-radius: 16px;
          padding: 1.5rem;
          text-align: center;
          transition: transform 0.3s ease;
        }

        .stat-card:hover {
          transform: translateY(-5px);
        }

        .stat-number {
         
          font-size: 2rem;
          font-weight: 700;
          margin-bottom: 0.5rem;
        }

        .stat-label {
          color: rgba(255,255,255,0.8);
          font-size: 0.9rem;
          font-weight: 500;
        }

        .illustration-container {
          display: flex;
          justify-content: center;
          align-items: center;
          padding: 2rem;
        }

        .broadcast-illustration {
          max-width: 100%;
          height: auto;
          border-radius: 16px;
          box-shadow: 0 8px 32px rgba(0,0,0,0.2);
          transition: transform 0.3s ease;
        }

        .broadcast-illustration:hover {
          transform: scale(1.02);
        }
      `}</style>

      <Content Page_title="" button_status={false}>
        {/* Header Section */}
        <div className="broadcast-container">
          <div className="broadcast-content">
            <div className="broadcast-header">
      
              <h1 className="broadcast-title text-white">   📢 Message Broadcast</h1>
              <p className="broadcast-subtitle">
                Send important messages to your users instantly
              </p>
            </div>

            <div className="broadcast-stats">
              <div className="stat-card">
                <div className="stat-number">{AllMessage?.data?.length || 0}</div>
                <div className="stat-label">Total Messages</div>
              </div>
              <div className="stat-card">
                <div className="stat-number">{AllBrokers?.length || 0}</div>
                <div className="stat-label">Active Brokers</div>
              </div>
              <div className="stat-card">
                <div className="stat-number">24/7</div>
                <div className="stat-label">Service Active</div>
              </div>
            </div>

            
          </div>
        </div>

        {/* Form Section */}
        <div className="enhanced-form-container">
          <div className="form-header p-0 d-block d-md-flex">
            <h3 className="form-title1">📝 Compose Message</h3>
            <p className="form-description">
              Create and send broadcast messages to your selected audience
            </p>
          </div>
          
          <Formikform1
            fieldtype={fields.filter((field) => !field.showWhen)}
            formik={formik}
            btn_name="Send"
          />
        </div>

        <div className="mt-5"></div>

        {/* Table Section */}
        <div className="enhanced-table-wrapper">
          <div className="table-header">
            <h3 className="table-title">📨 Message History</h3>
            <p className="table-description">
              View and manage all your broadcast messages
            </p>
          </div>
          
          <Table
            columns={columns}
            data={AllMessage?.data || []}
          />
        </div>

        <ToastButton />
      </Content>
    </>
  );
};

export default MsgBroadCast;